const tabs = document.querySelectorAll(".product-tab");

const panels = document.querySelectorAll(".product-tab-panel");

tabs.forEach((tab) => {

  tab.addEventListener("click", () => {

    const current = tab.dataset.tab;

    tabs.forEach((button) => {

      const active = button.dataset.tab === current;

      button.classList.toggle(
        "bg-secondary-green",
        active
      );

      button.classList.toggle(
        "text-primary-cream",
        active
      );

      button.classList.toggle(
        "bg-transparent",
        !active
      );

      button.classList.toggle(
        "text-secondary-green",
        !active
      );

    });

    panels.forEach((panel) => {

      panel.classList.toggle(
        "hidden",
        panel.dataset.panel !== current
      );

    });

  });

});